import React from "react";

const Button = (props) => {
  return (
    <button type={props.submit} className={props.className}>
      {props.children}
    </button>
  );
};

export default Button;
